{
  "page": {
    "title": "แคมเปญ"
  },
  "tab": {
    "campaigns": "แคมเปญ",
    "promotions": "โปรโมชั่น"
  },
  "toolbar": {
    "create": "สร้างแคมเปญ",
    "new_campaign": "+ สร้างแคมเปญ",
    "search_placeholder": "ค้นหาแคมเปญ…",
    "all_statuses": "ทุกสถานะ",
    "has_active": "มีที่กำลังใช้งาน",
    "has_finished": "สิ้นสุดทั้งหมด",
    "has_draft": "มีฉบับร่าง",
    "all_periods": "ทุกช่วงเวลา",
    "export": "ส่งออก"
  },
  "footer": {
    "showing": "แสดง {{shown}} จาก {{total}} แคมเปญ"
  },
  "column": {
    "account": "บัญชี",
    "name": "ชื่อ",
    "period": "ช่วงเวลา",
    "created_by": "สร้างโดย",
    "status": "สถานะ",
    "actions": "การดำเนินการ"
  },
  "rollup": {
    "active": "กำลังใช้งาน",
    "draft": "ฉบับร่าง",
    "finish": "สิ้นสุดแล้ว",
    "archived": "เก็บถาวร"
  },
  "form": {
    "name_label": "ชื่อแคมเปญ",
    "name_placeholder": "เช่น แคมเปญสงกรานต์ 2026",
    "create_title": "สร้างแคมเปญ",
    "rename_title": "เปลี่ยนชื่อแคมเปญ",
    "submit_create": "สร้าง",
    "submit_rename": "บันทึก",
    "cancel": "ยกเลิก",
    "err_name_required": "กรุณากรอกชื่อแคมเปญ"
  },
  "action": {
    "rename": "เปลี่ยนชื่อ",
    "archive": "เก็บถาวร",
    "delete": "ลบ"
  },
  "delete": {
    "confirm_title": "ลบแคมเปญ?",
    "confirm_body": "การดำเนินการนี้ไม่สามารถย้อนกลับได้",
    "blocked": "ไม่สามารถลบได้: แคมเปญนี้มีโปรโมชั่นที่กำลังใช้งานอยู่"
  },
  "empty": {
    "title": "ยังไม่มีแคมเปญ",
    "body": "สร้างแคมเปญแรกของคุณเพื่อจัดกลุ่มโปรโมชั่น"
  }
}
